<!-- @format -->
<script lang="ts">
  import type { ManageAPI } from "~/manage-api/types";
  import type { StoresKey } from "~/stores";
  import { getStoresContext } from "~/stores";

  export let request_store_key: StoresKey;
  export let store: ManageAPI.Store;
  export let isSearchResult: boolean = false;

  const { scdata, reverse_router } = getStoresContext(request_store_key);
</script>

<a 
  href={$reverse_router.routeStore(store, $scdata)} 
  class={`store-card fw-bold ${isSearchResult ? ' col-6 col-sm-4 col-lg-3' : ' col-6 col-lg-4'}`}
>
  <div class="logo-container">
    {#if store.logoURL}
      <img src={store.logoURL} alt={store.name} />
    {/if}
  </div>
  <b class="link">{store.name}</b>
</a>

<style lang="scss">
  .store-card {
    padding: 20px;
    margin-bottom: 0;
    text-decoration: none;
    padding-top: 0;
    padding-bottom: 30px;
    display: block;
    @media (max-width: 991px) {
      padding: 0 10px;
      margin-bottom: 1rem;
    }
    .logo-container {
      border: 2px solid var(--color-accent-primary);
      overflow: hidden;
      width: 100%;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      b {
        color: #000;
      }
    }
    .logo-container:after {
      content: '';
      display: block;
      padding-bottom: 75%;
    }
    img {
      position: absolute;
      max-height: 100%;
      max-width: 100%;
      padding: 0.5rem;
    }
    b {
      text-decoration: none;
      display: block;
      text-align: center;
      font-size: 16px;
      margin-top: 10px;
      color: var(--color-accent-primary);
      font-weight: bold;
    }
    b:hover {
      color: var(--color-black);
    }
  }
</style>
